var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateSurge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05999 8.85359H6.11999V13.6536C6.11999 14.7736 6.72665 15.0003 7.46665 14.1603L12.5133 8.42692C13.1333 7.72692 12.8733 7.14692 11.9333 7.14692H9.87332V2.34692C9.87332 1.22692 9.26665 1.00026 8.52665 1.84026L3.47999 7.57359C2.86665 8.28026 3.12665 8.85359 4.05999 8.85359Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateSurge);
export default __webpack_public_path__ + "static/media/update-surge.d2278987e9d8093606b6bfab770399cc.svg";
export { ForwardRef as ReactComponent };